import { All } from "./All";

const routes = [
    { route: "/", component: All }
];

export default routes;
